<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Pfwt8X/CoverDesign.jpg?1684515200226" alt="This image is the cover for the book Tulsi Vivah, 2018 Advent Calendar - Warmest Wishes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tulsi Vivah, 2018 Advent Calendar - Warmest Wishes
      </h1>
      <p class="bookDescription body article font2">
        <p>The festival of Tulsi Vivah ushers in the Hindu wedding season and tears away the love of Kristopher’s life. Three years of passion and tenderness are reduced to a shameful skeleton in the closet as Arjuna submits to the marriage his parents have arranged for him. His family has never even heard Kristopher’s name. </p> <p>The festival, a ritualistic wedding between the holy basil plant, Tulsi, and her eternal lover, Vishnu, is as much of a play-act as Arjuna’s upcoming nuptials, but he believes the wedding will honor his parents and please Vishnu. So why is his Tulsi plant—whose leaves heal and bless the devout, who is Vishnu's representative on earth—dying? Arjuna tends to her with all the care of a concerned parent, but it might take more than his devotion to save her. She might need Kris, with his clever green-fingers—and maybe a revived Tulsi can heal two hearts.</p><p><i>A story from the Dreamspinner Press 2018 Advent Calendar "Warmest Wishes."</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna Kaling
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c7365564